<div class="button-bar" [ngClass]="'bb-'+orientation">
  <div [ngClass]="'bb-btn-show-'+orientation">
    <button class="btn btn-secondary btn-sm" (click)="toggleButtons()" [ngbTooltip]="showWindows?'Hide windows':'Show windows'"
      [placement]="hintPlacement">
      <i class="fa" [ngClass]="showWindows?'fa-eye-slash':'fa-eye'"></i>
    </button>
  </div>
  <div *ngIf="showWindows" [ngClass]="'bb-btn-'+orientation">
    <button class="btn btn-secondary btn-sm" (click)="zoomIn()" [disabled]="zoom>=maxZoom" ngbTooltip="Zoom in"
      [placement]="hintPlacement">
      <i class="fa fa-plus"></i>
    </button>
  </div>
  <div *ngIf="showWindows" [ngClass]="'bb-btn-'+orientation">
    <button class="btn btn-secondary btn-sm" (click)="zoomOut()" [disabled]="zoom<=minZoom" ngbTooltip="Zoom out"
      [placement]="hintPlacement">
      <i class="fa fa-minus"></i>
    </button>
  </div>
  <div *ngIf="showWindows" [ngClass]="'bb-btn-'+orientation">
    <button class="btn btn-secondary btn-sm" (click)="zoomToFit()" ngbTooltip="Zoom to full extent"
      [placement]="hintPlacement">
      <i class="fa fa-arrows-alt"></i>
    </button>
  </div>
  <div *ngIf="showWindows" [ngClass]="'bb-btn-'+orientation">
    <button class="btn btn-secondary btn-sm"
            ngbTooltip="Download data for current map"
            (click)="downloadMap.emit()"
            [placement]="hintPlacement">
      <i class="fa fa-download"></i>
    </button>
  </div>
  <div *ngIf="showWindows" [ngClass]="'bb-btn-'+orientation">
    <button class="btn btn-secondary btn-sm"
            (click)="shareView.emit()"
            ngbTooltip="Copy sharing link to clipboard"
            [placement]="hintPlacement">
      <i class="fa fa-share-alt"></i>
    </button>
  </div>
  <div *ngIf="showWindows&&tours?.length" [ngClass]="'bb-btn-'+orientation">
    <button class="btn btn-secondary btn-sm"
            [ngbPopover]="toursPopover"
            ngbTooltip="Start a tour of the Global Water Monitor"
            #popRef="ngbPopover"
            [placement]="hintPlacement">
      <i class="fa fa-video-camera"></i>
    </button>
  </div>
  <div *ngIf="showWindows&&helpModal" [ngClass]="'bb-btn-'+orientation">
    <button class="btn btn-secondary btn-sm"
            (click)="helpModal.show()"
            ngbTooltip="Show welcome (help) screen"
            [placement]="hintPlacement">
      <i class="fa fa-question"></i>
    </button>
  </div>
  <div *ngIf="showWindows&&feedbackAddress" [ngClass]="'bb-btn-'+orientation">
    <a class="btn btn-secondary btn-sm"
       href="mailto:{{feedbackAddress}}?subject=Feedback on Global Water Monitor&body=Please enter your feedback here"
       (click)="mailtoClicked()">
      <i class="fa fa-envelope"></i>
    </a>
  </div>
  <!--
  <div *ngIf="showWindows">
    <button class="btn btn-secondary btn-sm"
            (click)="toggleTransparency()"
            [ngbPopover]="transparencyPopover"
            triggers="mouseenter:mouseleave"
            [openDelay]="500"
            [autoClose]="true"
            [closeDelay]="3000"
            [placement]="hintPlacement">
      <i class="fa" [ngClass]="(opacity<0.5)?'fa-circle-o':((opacity<0.9)?'fa-adjust':'fa-circle')"></i>
    </button>
  </div>
  <div *ngIf="showWindows&&basemaps?.length">
    <button class="btn btn-secondary btn-sm"
            (click)="toggleBaseLayer()"
            [ngbPopover]="basemapPopover"
            triggers="mouseenter:mouseleave"
            [openDelay]="500"
            [autoClose]="false"
            [closeDelay]="5000"
            [placement]="hintPlacement">
      <i class="fa" [ngClass]="baseLayer?.icon"></i>
    </button>
  </div>
  <div *ngIf="showWindows && mainLayer?.layer">
    <a class="btn btn-secondary btn-sm" [href]="mainLayer.downloadURL" target="blank">
      <i class="fa fa-download"></i>
    </a>
  </div> -->
</div>

<ng-template #toursPopover>
  <div class="tours-popover">
    <tour-selection [tours]="tours" (tourStarted)="_tourStarted($event)"></tour-selection>
  </div>
</ng-template>



<!--

<ng-template #transparencyPopover>
  <div class="transparency-popover">
    <div class="form-group">
      <label for="transparencySlider">Transparency</label>
      <input type="range"
             class="form-control-range"
             id="transparencySlider"
             [(ngModel)]="transparency"
             (ngModelChange)="transparencyChanged()"
             min="0"
             max="100">
    </div>
  </div>
</ng-template>

<ng-template #vectorPopover>
  <div class="vector-popover">
    <button class="btn btn-outline-secondary float-right" (click)="vp.close()">X</button>
    <app-vector-layer-selection [vectorLayers]="vectorLayers"
                                [currentZoom]="zoom"
                                (vectorLayerSelected)="vectorLayerChanged($event)">

    </app-vector-layer-selection>
  </div>
</ng-template> -->

<ng-template #feedbackPopup let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">Please email us</h4>
    <button type="button" class="btn btn-secondary close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>We'd love to hear from you.</p>
    <p>Send you feedback to <a href="mailto:{{feedbackAddress}}">{{feedbackAddress}}</a>.
      <span class="feedback-btn btn-group">
        <button class="btn btn-primary btn-sm" (click)="copyAddress()"><i class="fa" [ngClass]="addressCopied?'fa-check':'fa-copy'"></i></button>
      </span>
    </p>
  </div>
  <div class="modal-footer">
    <button autofocus type="button" class="btn btn-secondary" (click)="c('Close click')">Close</button>
  </div>
</ng-template>

